/**
 * A number typed into a field, or null when the text is not one.
 *
 * The field's own marks may sit round it ("50%", "45°", "x 12"), a comma is read as the
 * decimal point, and an exponent is read as one. Anything else — nothing at all, letters,
 * two numbers — is refused, so the field keeps the value it had. The old reading kept only
 * digits, points and signs: a cleared field set 0 (a layer vanished, a turned one snapped
 * upright), "12,5" became 125 and "1e3" became 13 (QA 2026-09-24, inspector-numbers-F12).
 */
export function readNumber(text: string): number | null {
  const clean = text.trim().replace(',', '.');
  const match = /^[^\d.+-]*([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)\s*[^\d.+-]*$/i.exec(clean);
  if (!match) return null;
  const value = Number(match[1]);
  return Number.isFinite(value) ? value : null;
}
